import {
  ARQUIVAR_MPF_NOTIFICACAO,
  GET_MPF_ALTERACOES_REVISAO,
  GET_MPF_MINHA_FILA,
  GET_MPF_NOTIFICACOES,
  GET_MPF_NOTIFICACOES_CONTAGEM,
  GET_MPF_TRANSICOES_DA_NOTICIA,
  MARCAR_MPF_NOTIFICACAO,
  MARCAR_TODAS_MPF_NOTIFICACOES,
} from 'volto-ministerio-publico-federal/constants';
import type { FiltroNotificacoes } from 'volto-ministerio-publico-federal/helpers/Notificacoes';

/**
 * Central de notificações do fluxo editorial (`@notificacoes`, backend
 * `services/notificacoes`). Toda chamada é do usuário autenticado: o backend
 * nunca aceita outro userid.
 */

/** Só os contadores: é a única chamada do polling do sino. */
export function getMpfNotificacoesContagem() {
  return {
    type: GET_MPF_NOTIFICACOES_CONTAGEM,
    request: { op: 'get', path: '/@notificacoes/contagem' },
  };
}

export function getMpfNotificacoes(
  filtro: FiltroNotificacoes = 'todas',
  bStart = 0,
  bSize = 20,
) {
  return {
    type: GET_MPF_NOTIFICACOES,
    filtro,
    bStart,
    request: {
      op: 'get',
      path: `/@notificacoes?filtro=${filtro}&b_start=${bStart}&b_size=${bSize}`,
    },
  };
}

/** `id` e `lida` viajam na ação para o reducer atualizar sem recarregar. */
export function marcarMpfNotificacao(id: number, lida = true) {
  return {
    type: MARCAR_MPF_NOTIFICACAO,
    id,
    lida,
    request: { op: 'patch', path: `/@notificacoes/${id}`, data: { lida } },
  };
}

export function marcarTodasMpfNotificacoes() {
  return {
    type: MARCAR_TODAS_MPF_NOTIFICACOES,
    request: { op: 'post', path: '/@notificacoes/marcar-todas-lidas' },
  };
}

export function arquivarMpfNotificacao(id: number) {
  return {
    type: ARQUIVAR_MPF_NOTIFICACAO,
    id,
    request: { op: 'del', path: `/@notificacoes/${id}` },
  };
}

export function getMpfMinhaFila() {
  return {
    type: GET_MPF_MINHA_FILA,
    request: { op: 'get', path: '/@minha-fila' },
  };
}

/**
 * Transições que o usuário pode fazer agora na notícia (`@workflow` só lista
 * as do estado atual permitidas a ele). Não passa por reducer: quem chama usa
 * a promessa, e o `getWorkflow` do Volto guardaria um único conteúdo global.
 */
export function getMpfTransicoesDaNoticia(path: string) {
  return {
    type: GET_MPF_TRANSICOES_DA_NOTICIA,
    request: { op: 'get', path: `${path}/@workflow` },
  };
}

/**
 * Texto de partida da revisão da notícia, para marcar o que os revisores
 * alteraram. Como as transições, não passa por reducer: quem chama usa a
 * promessa.
 */
export function getMpfAlteracoesRevisao(path: string) {
  return {
    type: GET_MPF_ALTERACOES_REVISAO,
    request: { op: 'get', path: `${path}/@alteracoes-revisao` },
  };
}
